import DataFetcherTemplate from "../hooks/fetchTemplate";

import BlockImageCabecera from "../components/BlockImageCabecera";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import Block3Columns from "../components/Block3Columns";
import Block4ColumnsText from "../components/Block4ColumnsText";
import Block2ColumnsText from "../components/Block2ColumnsText";
import Accordion from "../components/Accordion";
import BlockBackgroundImage from "../components/BlockBackgroundImage";
import BlockRightImage from "../components/BlockRightImage";
import BlockLeftImage from "../components/BlockLeftImage";
import FixedHeader from "../components/FixedHeader";
import { motion } from "framer-motion";
function CarismaIdente() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <FixedHeader
              video={item.field_video_portada}
              span0={<> "Sentado</>}
              span1="en las diferentes"
              span3={<>cátedras del mundo"</>}
              span4="Fernando Rielo"
            ></FixedHeader>
            <div className="bluebg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/servicios-juridicos">Carisma Idente</NavLink>
                  </>
                }
              ></Breadcumbs>
              <center>
                {" "}
                <p className="iconsize20 ">🎓🤍🙏</p>
                <motion.div
                  className="span0"
                  initial={{ y: 150, opacity: 0 }}
                  whileInView={{
                    y: 0,
                    opacity: 1,
                    transition: {
                      type: "spring",
                      stiffness: 200,
                    },
                  }}
                >
                  <div
                    className="layout6 fontsize14"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                </motion.div>
              </center>
              <br></br> <br></br>
            </div>

            <div>
              <BlockRightImage
                src={item.field_imagen2}
                content={
                  <>
                    <p className="iconsize20 ">🎓🙏 </p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>

              <BlockLeftImage
                src={item.field_imagen3}
                content={
                  <>
                    {" "}
                    <p className="iconsize20 ">🧡🧡 </p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
              ></BlockLeftImage>
              <div className=" bluebg">
                <BlockRightImage
                  src={item.field_imagen4}
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque4,
                        }}
                      />
                    </>
                  }
                ></BlockRightImage>
                <Block2ColumnsText
                  col1={
                    <>
                      <div className="width100">
                        <img src={item.field_imagen5}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque5,
                        }}
                      />
                    </>
                  }
                  col2={
                    <>
                      <div className="width100">
                        <img src={item.field_imagen6}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque6,
                        }}
                      />
                    </>
                  }
                ></Block2ColumnsText>
                <br></br> <br></br> <br></br>
              </div>

                    <motion.div
                  className="span0"
                  initial={{ y: 150, opacity: 0 }}
                  whileInView={{
                    y: 0,
                    opacity: 1,
                    transition: {
                      type: "spring",
                      stiffness: 200,
                    },
                  }}
                >
                   <div   className="fontsize14 layout6 padding">
                {" "}
                <center>
                  <p className="iconsize20">✨ </p>
                  <div
                  
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque7,
                    }}
                  />
                </center>
              </div>
                </motion.div> 
          
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/carisma-idente.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </>
  );
}

export default CarismaIdente;
